import { duration, easing } from "../motion";

/**
 * Semantic motion roles — intent-based duration/easing pairs for UI transitions.
 * No raw timing literals; all values resolve through primitive motion tokens.
 */
export const motion = {
  hover: {
    duration: duration.fast,
    easing: easing.hover,
  },
  /** Focus is keyboard-driven and high-frequency, so it never animates. */
  focus: {
    duration: duration.instant,
    easing: easing.linear,
  },
  press: {
    duration: duration.fast,
    easing: easing.out,
  },
  enter: {
    duration: duration.normal,
    easing: easing.out,
  },
  exit: {
    duration: duration.fast,
    easing: easing.out,
  },
  /** Scale from the trigger (transform-origin), never from center. */
  popover: {
    duration: duration.normal,
    easing: easing.out,
  },
  drawer: {
    duration: duration.modal,
    easing: easing.drawer,
  },
} as const;

export type TMotionSemantic = typeof motion;
